export const FILTER_TYPE_SINGLE_SELECT = "single-select";
export const FILTER_TYPE_MULTI_SELECT = "multi-select";
export const FILTER_TYPE_BOOLEAN = "boolean";
export const FILTER_TYPE_STRING = "string";
export const FILTER_TYPE_NUMBER = "number";
export const FILTER_TYPE_DATE = "date";
export const FILTER_TYPE_DATE_RANGE = "date-range";
export const FILTER_TYPE_DATE_OPTIONS = "date-options";
export const FILTER_TYPE_DATE_TIME_OPTIONS = "date-time-options";
export const FILTER_TYPE_DATE_TIME_STATISTICS_OPTIONS = "date-time-statistics-options";
export const FILTER_TYPE_DATE_EXTRA_OPTIONS = "date-extra-options";

export const EXACT_DATE = "EXACT_DATE";
export const BEFORE_DATE = "BEFORE_DATE";
export const AFTER_DATE = "AFTER_DATE";
export const RANGE_DATE = "RANGE_DATE";
export const MONTH = "MONTH";
export const THIS_YEAR = "THIS_YEAR";
export const LAST_12_MONTHS = "LAST_12_MONTHS";
export const LAST_24_HOURS = "LAST_24_HOURS";
export const LAST_48_HOURS = "LAST_48_HOURS";
export const LAST_WEEK = "LAST_WEEK";

export const EXACT_NUMBER = "EXACT_NUMBER";
export const GREATER_THAN = "GREATER_THAN";
export const SMALLER_THAN = "SMALLER_THAN";
export const RANGE_NUMBER = "RANGE_NUMBER";

export const NUMBER_OPTIONS = [
  {
    value: EXACT_NUMBER,
    text: "filterChips.exactNumber",
  },
  {
    value: GREATER_THAN,
    text: "filterChips.greaterThan",
  },
  {
    value: SMALLER_THAN,
    text: "filterChips.smallerThan",
  },
  {
    value: RANGE_NUMBER,
    text: "filterChips.range",
  },
];
export const DATE_STATISTICS_OPTIONS = [
  {
    value: RANGE_DATE,
    text: "filterChips.rangeDate",
  },
  {
    value: LAST_24_HOURS,
    text: "filterChips.last24Hours",
  },
  {
    value: LAST_48_HOURS,
    text: "filterChips.last48Hours",
  },
  {
    value: LAST_WEEK,
    text: "filterChips.lastWeek",
  },
];
export const DATE_OPTIONS = [
  {
    value: EXACT_DATE,
    text: "filterChips.exactDate",
  },
  {
    value: BEFORE_DATE,
    text: "filterChips.beforeDate",
  },
  {
    value: AFTER_DATE,
    text: "filterChips.afterDate",
  },
  {
    value: LAST_24_HOURS,
    text: "filterChips.last24Hours",
  },
  {
    value: LAST_48_HOURS,
    text: "filterChips.last48Hours",
  },
  {
    value: RANGE_DATE,
    text: "filterChips.rangeDate",
  },
];

export const DATE_EXTRA_OPTIONS = [
  {
    value: EXACT_DATE,
    text: "filterChips.exactDate",
    selectDate: true,
  },
  {
    value: BEFORE_DATE,
    text: "filterChips.beforeDate",
    selectDate: true,
  },
  {
    value: AFTER_DATE,
    text: "filterChips.afterDate",
    selectDate: true,
  },
  {
    value: RANGE_DATE,
    text: "filterChips.rangeDate",
    selectDate: true,
  },
  {
    value: MONTH,
    text: "filterChips.month",
    selectDate: true,
  },
  {
    value: THIS_YEAR,
    text: "filterChips.thisYear",
  },
  {
    value: LAST_12_MONTHS,
    text: "filterChips.last12months",
  },
];
